import React, { Component } from 'react';
// import Board from '../Board';

export default class BoardContainer extends Component {
  render() {
    return <div className="BoardContainer">Board</div>;
  }
}
